"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.json = {
    programs: [
        {
            value: "Barbering",
            name: "Barbering"
        }
    ],
    campuses: [
        {
            value: "Orangeburg",
            name: "Orangeburg"
        },
        {
            value: "Columbia",
            name: "Columbia"
        }
    ],
    states: [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "District of Columbia", abbreviation: "DC" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Lousiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virginia", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" }
    ],
    tabs: [
        {
            step: "1",
            title: "Application"
        },
        {
            step: "2",
            title: "Education Disclosure"
        },
        {
            step: "3",
            title: "Code of Computing"
        },
        {
            step: "4",
            title: "Felony Acknowledgement Form"
        },
        {
            step: "5",
            title: "Identity Authentication Form"
        },
        {
            step: "6",
            title: "Online Education Disclosure"
        },
        {
            step: "7",
            title: "CPA Eligibility Form"
        },
        {
            step: "8",
            title: "Technical Standards Form"
        },
        {
            step: "9",
            title: "HIM Technical Standards"
        },
        {
            step: "10",
            title: "Transferability of Credits Form"
        },
        {
            step: "11",
            title: "Disclosure of Info Mississippi"
        },
        {
            step: "12",
            title: "Finish & Submit"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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